import React from "react";
import { Link } from "react-router-dom";
import "./AboutHero.css";

export default function AboutHero() {
  return (
    <section className="about-hero" id="about">
      <div className="about-hero-eyebrow">ABOUT</div>
      <div className="about-hero-description">
        Learn more about who I am and what inspires my work
      </div>
      <div className="about-hero-container">
        <div className="about-hero-image">
          <img
            src="https://cdn.mupende.com/raw/MXHXBi.jpeg"
            alt="Charles David Mupende"
          />
        </div>
        <div className="about-hero-content">
          <h2 className="about-hero-title">
            Hi, I'm Charles – I design software products that drive growth.
          </h2>
          <p className="about-hero-description-box">
            I help companies and individuals build software that is simple,
            intuitive, and valuable. To maximize the impact of software
            solutions they need to be tailored to the needs of their users. I
            support the entire process from concept and design through
            development and delivery to ensure the final product truly drives
            value.
          </p>
          <Link to="/cv" className="about-hero-cv-link">
            View my CV
          </Link>
          <div className="about-hero-stats">
            <div className="about-hero-stat">
              <div className="about-hero-stat-number">5+</div>
              <div className="about-hero-stat-label">
                Software products launched from concept to market.
              </div>
            </div>
            <div className="about-hero-stat">
              <div className="about-hero-stat-number">4+</div>
              <div className="about-hero-stat-label">
                Years of experience in product management, business analysis,
                and software development.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
